module.exports = __webpack_public_path__ + "static/media/Img_7.9e9e0350.JPG";